module.exports = __webpack_public_path__ + "static/media/payment2.55777603.png";